export const RELEASE_TABS = ['notes', 'status'] as const;
export type ReleaseTab = (typeof RELEASE_TABS)[number];
